import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

/*
 * The backend embeds internal tool sentinels (e.g. `__ASSISTANT_ASK_USER__`)
 * directly in assistant message content. Markdown reads `__x__` as bold, so
 * left unstripped these render as a stray bold heading in the transcript.
 * Stripped here (not upstream) so both the live delta path and the REST
 * history path — which both ultimately render through this component — are
 * covered by one fix.
 */
export function stripInternalSentinels(content: string): string {
  return content.replace(/\s*__ASSISTANT_ASK_USER__\s*/g, '\n').trim();
}

/*
 * Renders assistant markdown content. remark-gfm adds tables / strikethrough /
 * autolinks / task lists; remark-breaks keeps single newlines as <br> (as in
 * companies/About.tsx). Links open in a new tab. Styling comes from assistant.css.
 */
const MarkdownBody = ({ content }: { content: string }) => (
  <ReactMarkdown
    remarkPlugins={[remarkGfm, remarkBreaks]}
    components={{
      a: ({ node, ...props }) => (
        <a {...props} target="_blank" rel="noreferrer" />
      ),
      // Block external image loads — a prompt injection could put conversation
      // data in an image query string to an attacker-controlled host.
      img: ({ alt }) => (alt ? <span>{alt}</span> : null),
    }}
  >
    {stripInternalSentinels(content)}
  </ReactMarkdown>
);

export default MarkdownBody;
